const print = (state = {}, action) => {
  switch(action.type){
    case 'ADD_PRINT':
      return action.data;

    case 'CLEAR_PRINT':
      return null;

    default:
      return state;
  }
}

export default print